import enCommon from './en/common';
import enHome from './en/home';
import enAbout from './en/about';
import enServices from './en/services';
import enBusiness from './en/business';
import enTenders from './en/tenders';
import enEvents from './en/events';
import enContact from './en/contact';

import frCommon from './fr/common';
import frHome from './fr/home';
import frAbout from './fr/about';
import frServices from './fr/services';
import frBusiness from './fr/business';
import frTenders from './fr/tenders';
import frEvents from './fr/events';
import frContact from './fr/contact';

const messages = {
  en: {
    translation: {
      ...enCommon,
      ...enHome,
      ...enAbout,
      ...enServices,
      ...enBusiness,
      ...enTenders,
      ...enEvents,
      ...enContact,
    },
  },
  fr: {
    translation: {
      ...frCommon,
      ...frHome,
      ...frAbout,
      ...frServices,
      ...frBusiness,
      ...frTenders,
      ...frEvents,
      ...frContact,
    },
  },
};

export default messages;